import ExaminationResultScoreCard, {
  ExaminationResultScoreCardProps,
} from './ExaminationResultScoreCard';
export default ExaminationResultScoreCard;
export type { ExaminationResultScoreCardProps };
